import { PublicClientApplication } from "@azure/msal-browser";
import * as microsoftTeams from "@microsoft/teams-js";
import { resolve } from "node:dns";

export class PortalState {
    private static _instance: PortalState;

    // private constructor() {

    // }

    public static get Instance() {
        // Do you need arguments? Make it a regular static method instead.
        return this._instance || (this._instance = new this());
    }

    public authProvider!: PublicClientApplication; // <- delete

    public teamsContext!: microsoftTeams.Context;
    public groups!: BwGroup[];
    public videos!: BwVideo[];

    public graphtoken = () => {
        return new Promise<string>(async (resolve, reject) => {
            microsoftTeams.authentication.getAuthToken({
                successCallback: (token: string) => {
                    fetch(this.ApiEndpoint + '/token', {
                        method: 'GET',
                        headers: { 'authorization': 'Bearer ' + token }
                    })
                    .then(res => res.json())
                    .then((token: any) => {
                        resolve(token.token);
                    })
                }
            })
        });
    }

    public ApiEndpoint!: string;
}

export class BwGroup {
    public GroupId!: string;
    public GroupName!: string;
    public Groupdescription!: string;
}

export class BwVideo {
    public id!: string;
    public Title!: string;
    public src!: string;
}

export const _PortalState = PortalState.Instance;